import { Component, h, Prop } from "@stencil/core";
import { CookieUtils } from "../../core/utils/CookieUtils";
import { StringUtils } from "../../core/utils/StringUtils";
import { getProvinceSelectionModalData } from "./ProvinceList";


@Component({
    tag: "snt-province-modal-selector",
    shadow: false,
    styleUrl:"province-modal-selector.scss"
})


export class ProvinceModal{

    @Prop() languageJson:string = StringUtils.empty();

    private languageStrings:object = {}

    private isCookieSet: boolean= false;

    private dropDownElement: HTMLSntDropdownElement;

    private modal: HTMLSntModalElement;

    private modalData:{}
    
    
    componentWillLoad(){
        const cookie = CookieUtils.getCookie("userProvince"); 
        try { this.languageJson && (this.languageStrings = JSON.parse(this.languageJson)) } catch(e) { console.error(e) }; 
        if(cookie!==""){
            this.isCookieSet=true;          
        }
        this.modalData=getProvinceSelectionModalData();
    }

    componentDidLoad() {
        if(this.modal) {
            this.modal.show();
        }  
    }  
    async handleSubmit(){
       let selectedProvince ="";
       try{ selectedProvince =await this.dropDownElement.getValue()} catch(e){};
       
       const dropDownele= document.getElementById('province-button-dropdown') as HTMLElement;
      
        if(selectedProvince ===""){
            dropDownele.focus();
            return;
        }
      (window as any).sharedProvinceCookie.ketchProvinceCookie(selectedProvince);
       this.modal.hide();
       
    }
    

    render() {
        if(this.isCookieSet){
            return null;
        }
        else{
            return [
                    <snt-modal 
                        id="province-selector"
                        style-classes="snt-modal"
                        mandatory
                        ref={(el) => this.modal=el as HTMLSntModalElement}
                        languageString="{&quot;close&quot;:&quot;Close&quot;}"
                        >
                        <snt-title-copy title-string={this.languageStrings["title"]} styleClasses="provinceModalHeader">
                        </snt-title-copy>
    
                        <snt-form>
                        <div class="form-row dropdownContainer">
                            <div class="col">
                                <label html-for="province">{this.languageStrings["dropdownLabel"]}</label>
                                <snt-dropdown
                                    name="province"
                                    placeholder-text={this.modalData["provincePlaceholder"]}
                                    labelText={this.languageStrings["dropdownLabel"]}
                                    required={true}
                                    ref={(el) => this.dropDownElement=el as HTMLSntDropdownElement}
                                >
                                    <snt-options>
                                    {this.modalData["provinces"].map((option)=>(
                                        <snt-item
                                        data-key={option.value}
                                        value={option.label}
                                        ></snt-item>
                                    ))}

                                    </snt-options>
                                </snt-dropdown>
                                <div data-for="province" id="province_error">
                                    <div
                                        data-error
                                        data-empty-value
                                        class="hidden"
                                        aria-hidden="false"
                                    >
                                       {this.languageStrings["errorMessage"]}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row provinceModalNotes">
                            <div class="col">
                                <p> {this.languageStrings["copy"]}</p>
                            </div>
                        </div>
                        <snt-button
                            class="submit-button"
                            style-classes="cta theme-default"
                            buttonId="btn-province-selector"
                            onClick={this.handleSubmit.bind(this)}
                        >
                            {this.languageStrings["ctaButton"]}
                        </snt-button>
                        </snt-form>
                        
                    </snt-modal>
                
            ]
        }
        
    }
}